import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import {
  selectSettingsForActivities,
  setSettingsForActivities,
} from 'store/slices/settings'

import { SettingItem, Switch } from 'components'
import Link from 'features/i18n/router/Link'

export const ActivitySettingModal = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { singleFeed } = useSelector(selectSettingsForActivities)

  return (
    <div className="Modal__wrapper Modal__wrapper--auto-h TimelineFilterModal">
      <div className="Modal__header">
        <Link className="Modal__header__close" to={location.pathname} />

        <h2 className="Modal__header__h2">
          {t('activity_page.settings.title')}
        </h2>
      </div>

      <div className="Modal__body">
        <SettingItem label={t('activity_page.settings.single_feed')}>
          <Switch
            checked={singleFeed}
            onChange={(c) =>
              dispatch(
                setSettingsForActivities({
                  key: 'singleFeed',
                  value: c,
                })
              )
            }
          />
        </SettingItem>
      </div>
    </div>
  )
}
